import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Input,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import gsap from 'gsap';
import { JsonKey } from 'src/app/data/type/locale-copy-key';
import { LocalizationService } from 'src/app/service/localization.service';
import { TvFeature } from 'src/app/data/enum/tv-feature';

@Component({
  selector: 'app-c04-opening-screen',
  templateUrl: './c04-opening-screen.component.html',
  styleUrls: ['./c04-opening-screen.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class C04OpeningScreenComponent implements OnInit, AfterViewInit {
  @ViewChild('openingScreenRef') openingScreenRef: ElementRef;
  @Input() featureName: TvFeature;
  public modalElement: HTMLDivElement | null;
  public copy: string;

  constructor(private localizationService: LocalizationService) {}

  ngAfterViewInit(): void {
    this.modalElement = this.openingScreenRef.nativeElement;
    gsap.set(this.modalElement, { autoAlpha: 0 });
  }

  ngOnInit(): void {
    this.copy = this.localizationService.translate(
      JsonKey[`OPENING_SCREEN_${this.featureName}_COPY`],
    );
  }

  setupIntroTimeline() {
    const timeline = gsap.timeline({
      yoyo: true,
      repeat: 1,
      repeatDelay: 3,
      ease: 'none',
    });
    const modalChildrenSelector = gsap.utils.selector(this.modalElement);
    const introCopyElement = modalChildrenSelector('.intro-copy');

    timeline
      .to(this.modalElement, { autoAlpha: 1, duration: 1.5 }, 0.5)
      .fromTo(
        introCopyElement,
        { autoAlpha: 0, y: 30, duration: 0.75 },
        { autoAlpha: 1, y: 0, duration: 0.75 },
        '-=0.75',
      );
    return timeline;
  }
}
